module.exports = __webpack_public_path__ + "static/media/vibhu.6297737a.jpg";